





















































































































import { Component, Vue } from 'vue-property-decorator'
import adminPanelApi from '@/api/admin-panel'
import {GlobalSettingsAEditDto, TelephonyServiceInfoDto} from "@/global";

@Component({
})
export default class AdminPanel_Server extends Vue {
    isLoading = true;
    isButtonsDisabled = false;

    settings: GlobalSettingsAEditDto | null = null;

    isTsInfoButtonsDisabled = false;
    tsInfo: TelephonyServiceInfoDto | null = null;

    mounted() {
        // this.isLoading = true;
        //
        // adminPanelApi.getGlobalSettings(((s) => {
        //     this.settings = s;
        //
        //     this.isLoading = false;
        // }), errorMessage => {
        //     this.showError(errorMessage);
        //
        //     this.isLoading = false;
        // });

        this.updateTelephonyServiceInfo();
    }

    get validateForm(): boolean {
        return !this.veeErrors.any();
    }

    get isOrganizationCreate() {
        return this.$route.name === 'create-organization';
    }

    get appVersion() {
        return APP_VERSION || '0';
    }

    validateState(ref: string) {
        if (this.veeFields[ref] &&
            (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
            return !this.veeErrors.has(ref);
        }

        return null
    }

    showSuccess() {
        this.$bvToast.toast("Операція успішно завершена", {
            title: "Успіх",
            variant: "success"
        })
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    updateTelephonyServiceInfo() {
        this.isTsInfoButtonsDisabled = true;

        adminPanelApi.telephonyServiceInfo(tsInfo => {
            this.tsInfo = tsInfo;

            this.isTsInfoButtonsDisabled = false;
        }, errorMessage => {
            this.showError(errorMessage);

            this.isTsInfoButtonsDisabled = false;
        })
    }

    resetCacheWithConfirm() {
        this.$bvModal.msgBoxConfirm(`Ви дійсно хочете скинути кеш?`, {
            title: 'Скинути кеш',
            size: 'sm',
            okVariant: 'warning',
            okTitle: 'Так',
            cancelTitle: 'Відміна',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
            .then(value => {
                if (value) {
                    this.resetCache()
                }
            })
            .catch(err => {
                // An error occurred
            })
    }

    resetCache() {
        this.isButtonsDisabled = true;

        adminPanelApi.resetCache(data => {
            if (data.success) {
                this.showSuccess();
            }

            this.isButtonsDisabled = false;
        }, errorMessage => {
            this.showError(errorMessage);

            this.isButtonsDisabled = false;
        })
    }

    updateUserSearchVisibilityWithConfirm() {
        this.$bvModal.msgBoxConfirm(`Ви дійсно хочете перерахувати видимість + скинути кеш?`, {
            title: 'Перерахувати видимість + Скинути кеш',
            size: 'sm',
            okVariant: 'warning',
            okTitle: 'Так',
            cancelTitle: 'Відміна',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
            .then(value => {
                if (value) {
                    this.updateUserSearchVisibility()
                }
            })
            .catch(err => {
                // An error occurred
            })
    }

    updateUserSearchVisibility() {
        this.isButtonsDisabled = true;

        adminPanelApi.updateUserSearchVisibility(data => {
            if (data.success) {
                this.showSuccess();
            }

            this.isButtonsDisabled = false;
        }, errorMessage => {
            this.showError(errorMessage);

            this.isButtonsDisabled = false;
        })
    }

    async updateGlobalSettings() {
        this.isButtonsDisabled = true;

        let isValid = this.$helpers.isExists(this.settings);

        if (!await this.$validator.validateAll()) {
            isValid = false;
        }

        if (isValid) {
            adminPanelApi.updateGlobalSettings(this.settings!, (data) => {
                if (data.success) {
                    this.$bvToast.toast("Зміни успішно збережені", {
                        title: "Успіх",
                        variant: "success"
                    });
                } else {
                    this.showError()
                }

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        } else {
            this.isButtonsDisabled = false;
        }
    }
}
